import { gql } from '@apollo/client'

const UPDATE_CHALLENGE_IMAGE_DETAILS_MUTATION = gql`
  mutation updateChallengeImageDetails(
    $id: ID!
    $data: ChallengeImageDetailsInput!
  ) {
    updateChallengeImageDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      imageUrl
    }
  }
`

export default UPDATE_CHALLENGE_IMAGE_DETAILS_MUTATION
